import {Badge} from "@/components/ui/badge";
import {orderStatusBadgeVariant} from "./adminStatus";
import {AdminStatusBadge} from "./AdminStatusBadge";

type Props = {
  children: React.ReactNode;
  variant?: "default" | "secondary" | "success" | "warning" | "danger" | "outline";
  status?: number;
  className?: string;
};

/** Prefer AdminStatusBadge for status labels; AdminBadge remains for generic chips. */
export function AdminBadge({children, variant, status, className}: Props) {
  if(status !== undefined) {
    return (
      <AdminStatusBadge status={status} className={className}>
        {children}
      </AdminStatusBadge>
    );
  }
  const v = variant ?? "default";
  if(v === "success" || v === "warning" || v === "danger" || v === "secondary") {
    return (
      <AdminStatusBadge
        tone={v === "secondary" ? "draft" : v === "danger" ? "danger" : v === "success" ? "success" : "warning"}
        className={className}
      >
        {children}
      </AdminStatusBadge>
    );
  }
  return <Badge variant={v === "outline" ? "outline" : orderStatusBadgeVariant(0)} className={className}>{children}</Badge>;
}

export function AdminNotifyBadge({count}: {count: number}) {
  if(count <= 0) return null;
  return <AdminStatusBadge tone="danger" className="admin-notify-badge">{count}</AdminStatusBadge>;
}
